<div class="details-page-skeleton container" *ngIf="!dataProduct && loading" [ngClass]="lang == 'ar' ? 'ar-dir' : ''">
  <div class="main-details-body">
    <div class="img-zoom-skeleton-container">
      <div class="light-animate-shimmer main-image"></div>
      <div class="thumb-image-container">
        <div class="light-animate-shimmer thumb-image"></div>
        <div class="light-animate-shimmer thumb-image"></div>
        <div class="light-animate-shimmer thumb-image"></div>
        <div class="light-animate-shimmer thumb-image"></div>
      </div>
    </div>
    <div class="main-details-skeleton-container">
      <div class="light-animate-shimmer name-shimmer"></div>
      <div class="light-animate-shimmer price-shimmer"></div>
      <div class="light-animate-shimmer description-shimmer"></div>
      <div class="light-animate-shimmer description-shimmer"></div>
      <hr />
      <div class="options-container">
        <div class="light-animate-shimmer option-name"></div>
        <div class="options-list">
          <div class="light-animate-shimmer option"></div>
          <div class="light-animate-shimmer option"></div>
          <div class="light-animate-shimmer option"></div>
          <div class="light-animate-shimmer option"></div>
        </div>
      </div>
      <div class="options-container">
        <div class="light-animate-shimmer option-name"></div>
        <div class="options-list">
          <div class="light-animate-shimmer option"></div>
          <div class="light-animate-shimmer option"></div>
        </div>
      </div>
      <div class="functions-container">
        <div class="light-animate-shimmer function"></div>
        <div class="light-animate-shimmer function"></div>
        <div class="light-animate-shimmer add-to-cart"></div>
      </div>
      <div class="key-features">
        <div class="light-animate-shimmer features-header"></div>
        <ul>
          <li class="light-animate-shimmer feature-item long-item"></li>
          <li class="light-animate-shimmer feature-item"></li>
          <li class="light-animate-shimmer feature-item long-item"></li>
          <li class="light-animate-shimmer feature-item long-item"></li>
          <li class="light-animate-shimmer feature-item"></li>
        </ul>
      </div>
    </div>
  </div>
</div>
<ng-container *ngIf="dataProduct && dataProduct?.active;">
  <div style="min-height: 80vh">
    <div class="inner-container">
      <div class="product-detail-page">
        <embryo-ShopDetails 
          [currency]="embryoService ? embryoService.currency : ''" 
          [detailData]="dataProduct"
          [installment]="installment"
          [lang]="lang">
        </embryo-ShopDetails>
        <div class="bg-grey section-gap" *ngIf="relatedProducts?.length"
          style="padding-top: 0rem; padding-bottom: 2rem">
          <div class="container">
            <div class="block-title text-center gap">
              <h2>{{ 'productDetails.relatedProducts' | translate }}</h2>
            </div>
            <div class="swiper-container">
              <swiper [config]="bigSwiperConfig" class="mySwiper" #relatedSwiper>
                <ng-template swiperSlide *ngFor="let product of relatedProducts" class="swiper-slide">
                  <app-updated-product-card (addToCart)="addToCart($event)" *ngIf="product" [product]="product">
                  </app-updated-product-card>
                </ng-template>
              </swiper>
            </div>
          </div>
        </div>
        <div 
          class="section-gap" 
          [ngClass]="{'bg-grey': !environmentVariables?.NEW_PRODUCTS_DETAILS_UI, 'bg-white': environmentVariables?.NEW_PRODUCTS_DETAILS_UI}"
          *ngIf="productsList?.length" 
          style="padding-top: 0rem; padding-bottom: 2rem">
          <div class="container">
            <div class="block-title text-center gap">
              <h2 *ngIf="!environmentVariables?.NEW_PRODUCTS_DETAILS_UI">
                {{ 'productDetails.youMightAlsoLike' | translate }}
              </h2>
              <span class='h2-title' *ngIf="environmentVariables?.NEW_PRODUCTS_DETAILS_UI">
                <span class="similar-product-highlight d-inline-block position-relative fs-28 fw-bold">
                  {{ 'productDetails.similarProducts' | translate }}
                </span>
              </span>
            </div>
            <div class="px-2">
              <div class="swiper-container">
                <swiper [config]="bigSwiperConfig" class="mySwiper" #newSwiper>
                  <ng-template swiperSlide *ngFor="let product of productsList" class="swiper-slide">
                    <app-updated-product-card (addToCart)="addToCart($event)" *ngIf="product" [product]="product">
                    </app-updated-product-card>
                  </ng-template>
                </swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<!-- #nonActiveProducts -->
<ng-container *ngIf="showNotAvaliableSection">
  <ng-template >
    <div *ngIf="!loading" class="section-gap-lg text-center cartEmpty not-available">
      <div class="mb-4">
        <mat-icon class="material-icons fav-icon"    alt="hdie-source-empty">
          hide_source
        </mat-icon>
        <h4>{{ 'productDetails.unavailableProduct' | translate }}</h4>
        <a href="javascript:void(0)" class="primary-color" [routerLink]="['/' + lang + '/']">
          {{ 'cart.goForShopping' | translate }}</a>
      </div>
    </div>
  </ng-template>
</ng-container>


<div class="loading-spinner" *ngIf="!dataProduct && !loading">
  <app-loading></app-loading>
</div>
